<template>
  <b-form-group
    label="Açıklama"
    label-for="notes"
  >
    <b-form-input
      id="notes"
      v-model="dataList[keyNumber].notes"
      placeholder="Açıklama"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'NotesText',
  components: {
    BFormGroup,
    BFormInput,
  },
  props: {
    keyNumber: {
      type: Number,
      required: true,
    },
  },
  computed: {
    dataList() {
      return this.$store.getters['productPortions/dataList']
    },
  },
}
</script>
